import React, { Component } from "react";

class SearchBox extends Component {
  render() {
    return (
      <div className="search-box">
        {/* Row 1 */}
        <div className="search-row">
          <div className="input-box">
            <label>Destination City</label>
            <input type="text" placeholder="Goa" />
          </div>

          <div className="input-box">
            <label>Trip Start Date</label>
            <input type="date" />
          </div>

          <div className="input-box">
            <label>No of Passengers</label>
            <select>
              <option>2 Adults, 2 Children</option>
            </select>
          </div>
        </div>

        {/* Row 2 – Hotel Standard */}
        <div className="hotel-row">
          <span className="hotel-label">Hotel Standard</span>

          <div className="hotel-options">
            <button className="hotel-btn">3★</button>
            <button className="hotel-btn">4★</button>
            <button className="hotel-btn active">5★</button>
          </div>

          <div className="meal-options">
            <label>
              <input type="checkbox" /> Add Lunch
            </label>
            <label>
              <input type="checkbox" /> Add Dinner
            </label>
          </div>
        </div>
      </div>
    );
  }
}

export default SearchBox;
